import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class IdService {
  uuid(): string {
    return crypto.randomUUID();
  }

  shortId(): string {
    return this.uuid().split('-').at(-1) ?? this.uuid();
  }
}